import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/pro-regular-svg-icons';
import * as styles from './Chips.css';

export type ChipsProps = {
  values: string[];
  onRemove: (value: string) => void;
  disabled?: boolean;
};

export const Chips = ({ values, onRemove, disabled }: ChipsProps) => {
  if (values.length === 0) return null;
  return (
    <div className={styles.list}>
      {values.map((value) => (
        <span key={value} className={styles.chip}>
          {value}
          <button
            type="button"
            className={styles.remove}
            onClick={() => onRemove(value)}
            disabled={disabled}
            aria-label={`Remove ${value}`}
          >
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </span>
      ))}
    </div>
  );
};
